import { render, staticRenderFns } from "./AdvantagesSection.vue?vue&type=template&id=aceda694&scoped=true&"
import script from "./AdvantagesSection.vue?vue&type=script&lang=js&"
export * from "./AdvantagesSection.vue?vue&type=script&lang=js&"
import style0 from "./AdvantagesSection.vue?vue&type=style&index=0&id=aceda694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceda694",
  null
  
)

export default component.exports